import Box from '@mui/material/Box';

import { FeedbackComponentContainer } from '../Layout/FeedbackComponentContainer';

import { FallbackComponent } from '../../../common/components/FallbackComponent/FallbackComponent';

interface LandingFallbackComponentProps {
  matchesMD: boolean;
}

// Inspired by the former Facebook spinners.
export const LandingFallbackComponent = (
  { matchesMD }: LandingFallbackComponentProps,
) => (
  <FeedbackComponentContainer matchesMD={matchesMD}>
    <Box
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        maxWidth: '256px',
      }}
    >
      <FallbackComponent />
    </Box>
  </FeedbackComponentContainer>
);
